import { render } from "./CoffeeMug.vue?vue&type=template&id=33b58709"
import script from "./CoffeeMug.vue?vue&type=script&lang=js"
export * from "./CoffeeMug.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__